// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import './api/axiosInterceptor'; // side-effect import — registers the interceptor
import ErrorBoundaryWrapper from './components/ErrorBoundary/ErrorBoundaryWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundaryWrapper componentName="Application Root">
  <Provider store={store}>
    <App />
  </Provider>
  </ErrorBoundaryWrapper>
);
